import SignupForm from "./_form/";

const Signup = () => {
  return (
    <div className="w-100 h-100 flex-column d-flex align-items-center justify-content-center">
      <h1>Signup</h1>
      <SignupForm />
    </div>
  );
};

export default Signup;
